import React, { useCallback, useState } from 'react';
import { Paginator, OnPaginateData } from './Paginator';

type Props = {
  /**
   * Page index used for initial value of interal page index state.
   */
  initialPageIndex?: number;

  /**
   * Array of page URLs.
   */
  pageUrls: Array<string>;

  /**
   * Optional handler for when a pagination button is clicked.
   */
  onPaginate?: (
    b: OnPaginateData,
    a: React.MouseEvent<Element, MouseEvent>
  ) => void;

  /**
   * Optional threshold of number of pages at which the paginator buttons will be rendered in condensed mode.
   */
  condenseAt?: number;
};

/**
 * Renders a `Pagination` component that handles pagination via internal state.
 */
export const PaginatorStateful = ({
  initialPageIndex = 0,
  onPaginate,
  ...props
}: Props) => {
  const [currentPageIndex, setCurrentPageIndex] = useState(initialPageIndex);
  const onPaginateStateful = useCallback(
    (data: OnPaginateData, event: React.MouseEvent<Element, MouseEvent>) => {
      setCurrentPageIndex(data.pageIndex);

      if (onPaginate) {
        onPaginate(data, event);
      }
    },
    [onPaginate]
  );

  return (
    <Paginator
      {...props}
      currentPageIndex={currentPageIndex}
      onPaginate={onPaginateStateful}
    />
  );
};
